import { scrollToHash, scrollToTop } from '@shared/Frontend/utils/html'
import * as React from 'react'
import '../../../../../Styling/styleguide/stylesheets/styleguide.scss' // SHELL STYLES
import { styleguideAbout } from './pages/about.sg'
import { styleguideComponents } from './pages/components.sg'
import { styleguideCompositions } from './pages/compositions.sg'
import { styleguideGuidelines } from './pages/guidelines.sg'
import { styleguideObjects } from './pages/objects.sg'
import { styleguideTokens } from './pages/tokens.sg'

const $breakpoint = 768

const apply_token_to_url = (token: string): void => {
  let address: string = window.location.href
  if (address.endsWith('/')) {
    address = address.slice(0, address.length - 1)
  }
  const tmp = address.split('#')
  window.location.href = tmp[0] + '#' + token
}

export const Styleguide = ({ currentPath }: { currentPath: string }) => {
  scrollToTop()
  scrollToHash()
  return (
    <article className="styleguide">
      <div className="styleguide__main">
        <header className="styleguide__header">
          <div className="styleguide__brand styleguide--styled">
            <a className="styleguide__logo-link" href="/styleguide">
              <h1 className="sr-text">Styleguide {sitename}</h1>
              <svg
                className="styleguide__logo"
                height="80"
                viewBox="0 0 239 80"
                width="239"
                xmlns="http://www.w3.org/2000/svg"
              >
                <mask id="a" fill="#fff">
                  <path d="m0 77.1375061h238.570654v-76.5525536h-238.570654z" fill="#fff" fill-rule="evenodd" />
                </mask>
                <g fill="none" fill-rule="evenodd">
                  <g transform="translate(0 1.268874)">
                    <path d="m169.975093 47.3760311h68.595561v-46.7910786h-68.595561z" fill="#fff" />
                    <path d="m171.587489 45.7627811h65.374182v-43.56713931h-65.374182z" fill="#253a79" />
                    <path d="m235.025515 43.8249179v-38.32108933l-38.310846 38.32108933z" fill="#ff8702" />
                    <g fill="#fffffe">
                      <path d="m173.525865 4.13418786v14.78215004c9.268078 1.1395178 20.679475.8450357 29.328714-4.8627965 3.141996-2.073325 5.522607-4.56063211 8.459746-6.13888569.002561-.00170714.005975-.00256071.008536-.00341428l-.007682-.00256072c2.026379-1.08915714 4.734761-1.20268214 6.332646.22705 1.59874 1.43058572.44215 1.63629643.44215 1.63629643l-.91076-.041825-1.073793-.07938214c-.009389-.00085357-.018779-.00085357-.028168-.00170714l-.001707.00256071-.005122-.00256071c-.826257-.04609286-1.741285.14681428-2.652046.80918574-3.127486 2.2747678-2.39 6.6774893.273996 8.2062357 1.465583.8416214 3.812904 1.2897464 5.805993-.3695964l14.156482-14.16075004z" />
                      <path d="m224.319254 27.1451932-1.39815-1.3990036-1.397296 1.3990036 1.397296 1.39815z" />
                      <path d="m225.547885 31.9190475-.494218 1.8548107 2.719479.7417536-.046093.0930393c-.564211 1.0439178-1.299136 2.515475-1.773722 3.8632643h-2.073325v-6.7380929h-1.916267v6.7380929h-2.073325c-.47544-1.3477893-1.209511-2.8193465-1.773722-3.8632643l-.046946-.0930393 2.720332-.7417536-.495072-1.8548107-4.882428 1.2982821s2.842393 4.6980572 3.028471 7.1708536h8.961647c.186078-2.4727964 3.028471-7.1708536 3.028471-7.1708536z" />
                      <path d="m218.440879 30.6204239h8.961646v-1.3793714h-8.961646z" mask="url(#a)" />
                    </g>
                  </g>
                  <g fill="#fffffe" transform="translate(0 20.381961)">
                    <path d="m111.825795 54.5817957v-9.8749678l-3.332343 9.0734642h-1.674707l-3.244425-9.0930964v9.8946h-1.474971v-12.15315h2.386586l3.369046 9.4003822 3.462939-9.4003822h2.130515v12.15315z" />
                    <path d="m122.652581 54.7826411c-.837354 0-1.273529-.58555-1.438268-1.3298643-.80065.7280964-1.675561 1.3298643-2.803129 1.3298643-1.423757 0-2.551325-.9824607-2.551325-2.4412143 0-.9124679.380693-1.6226393 1.11135-2.1501464 1.165125-.8578393 2.622172-.8749108 4.006665-.8749108v-1.0755c0-1.093425-.510436-1.5492321-1.584229-1.5492321-.982461 0-1.913707.3474036-2.770693.7835786v-1.3298643c.911614-.400325 2.022964-.6734679 3.024204-.6734679.856985 0 1.787378.1997357 2.407071.854425.509582.5479929.546286 1.2026822.546286 1.9145607v4.0442215c0 .675175.03585 1.368275.892836 1.368275.090478 0 .180103 0 .272289-.0196322l.108403.8928357c-.380692.1638858-.798942.2560715-1.22146.2560715zm-1.674707-4.5196607c-.180958 0-.383254-.0170715-.564211-.0170715-1.129275 0-2.953357.4191036-2.953357 1.8394465 0 .8015035.637618 1.3853464 1.423757 1.3853464.783578 0 1.491189-.4191036 2.093811-.8928357z" />
                    <path d="m130.07208 46.8921414c-1.20439 0-2.004186.8365-2.550472 1.8206679v5.8691571h-1.621786v-8.9104321h1.621786v1.6764143c.562504-1.0925715 1.530454-1.87615 2.786057-1.87615.163032 0 .349111 0 .51129.0349964v1.511675c-.254365-.089625-.472025-.1263286-.746875-.1263286" />
                    <path d="m132.770475 44.0497486h1.620079v-1.6209322h-1.620079zm0 10.5322178h1.620079v-8.9095785h-1.620079z" />
                    <path d="m143.302437 54.5817957v-6.214c0-.8194286-.329479-1.4928964-1.257311-1.4928964-1.275236 0-2.132221.9466107-2.789471 1.9307786v5.7761178h-1.619225v-8.9095786h1.619225v1.6755608c.711878-1.057575 1.80445-1.87615 3.11895-1.87615 1.63971 0 2.549618 1.129275 2.549618 2.7152107v6.3949571z" />
                    <path d="m148.988247 50.3730911c.199735 1.929925 1.043064 3.1872357 3.113828 3.1872357.894543 0 1.643979-.2364393 2.481332-.5462857v1.2760893c-.911614.2535107-1.842007.4925107-2.789471.4925107-2.730575 0-4.444546-2.0221107-4.444546-4.6844 0-2.3328107 1.311085-4.6263572 3.881189-4.6263572 2.587175 0 3.387825 2.2039215 3.387825 4.4266215v.4745857zm3.808635-2.56925c-.270582-.711025-.909053-1.11135-1.656782-1.11135-1.475825 0-1.968335 1.200975-2.076739 2.4779178h3.933257c-.016218-.4575143-.036703-.9295393-.199736-1.3665678z" />
                    <path d="m162.749611 44.0497486h1.621785v-1.6209322h-1.621785zm0 10.5322178h1.621785v-8.9095785h-1.621785z" />
                    <path d="m173.280036 54.5817957v-6.214c0-.8194286-.327771-1.4928964-1.255603-1.4928964-1.275236 0-2.133075.9466107-2.787765 1.9307786v5.7761178h-1.621785v-8.9095786h1.621785v1.6755608c.710172-1.057575 1.802743-1.87615 3.112975-1.87615 1.639711 0 2.552179 1.129275 2.552179 2.7152107v6.3949571z" />
                    <path d="m185.380009 52.9605221c0 1.18305-.090479 2.6221715-.80065 3.6251179-.765654 1.093425-2.25855 1.4391214-3.515861 1.4391214-1.019164 0-2.021257-.1638857-2.988354-.4908035l.184372-1.3853465c.909907.4370286 1.748968.6555429 2.766425.6555429 1.952118 0 2.734843-1.0191643 2.734843-2.8987286v-1.4024178c-.567625 1.1676857-1.659343 1.8795642-2.950797 1.8795642-2.441214 0-3.480864-2.151-3.480864-4.319925 0-2.3336642 1.294014-4.5905071 3.860703-4.5905071 1.130983 0 1.842861.3798393 2.570958 1.2197536v-1.0200179h1.619225zm-1.619225-5.156425c-.638472-.675175-1.385347-1.1122035-2.331958-1.1122035-1.859078 0-2.386585 1.8394464-2.386585 3.3707535 0 1.3853465.400325 2.897875 2.076739 2.897875 1.11135 0 1.948704-.6581035 2.641804-1.4587535z" />
                    <path d="m189.447874 50.3730911c.198029 1.929925 1.040504 3.1872357 3.114682 3.1872357.893689 0 1.640564-.2364393 2.478772-.5462857v1.2760893c-.911615.2535107-1.841154.4925107-2.789472.4925107-2.731428 0-4.443693-2.0221107-4.443693-4.6844 0-2.3328107 1.310232-4.6263572 3.880336-4.6263572 2.587175 0 3.388679 2.2039215 3.388679 4.4266215v.4745857zm3.806075-2.56925c-.270582-.711025-.909054-1.11135-1.654221-1.11135-1.476679 0-1.970897 1.200975-2.0793 2.4779178h3.935817c-.017071-.4575143-.037557-.9295393-.202296-1.3665678z" />
                    <path d="m203.549301 54.5817957v-6.214c0-.8194286-.325211-1.4928964-1.25475-1.4928964-1.27609 0-2.133075.9466107-2.786057 1.9307786v5.7761178h-1.623493v-8.9095786h1.623493v1.6755608c.708464-1.057575 1.802742-1.87615 3.113828-1.87615 1.638004 0 2.549618 1.129275 2.549618 2.7152107v6.3949571z" />
                    <path d="m213.86548 54.5817957v-1.6772678c-.709318 1.0567214-1.785672 1.8778571-3.114683 1.8778571-1.620932 0-2.551325-1.1480536-2.551325-2.7143571v-6.3958108h1.623493v6.1755893c0 .4199572.034997.8023572.328625 1.1301286.234732.2543643.582136.4191036.926979.4191036 1.239386 0 2.148439-1.0029465 2.786911-1.9495572v-5.7752643h1.622639v8.9095786z" />
                    <path d="m218.735361 44.0497486h1.620932v-1.6209322h-1.620932zm0 10.5322178h1.620932v-8.9095785h-1.620932z" />
                    <path d="m225.27534 46.8921414v4.9370572c0 1.0755.34655 1.750675 1.512528 1.750675.273997 0 .528361-.0367036.783579-.1092572v1.11135c-.419957.1084036-.856986.2005893-1.294868.2005893-1.655929 0-2.621318-1.0200178-2.621318-2.6622893v-5.228125h-1.112203v-1.2206071h1.112203v-1.6217857l1.620079-.1459607v1.7677464h2.331103v1.2206071z" />
                    <path d="m232.073097 57.82605h-1.674707l1.454486-3.244425-3.460379-8.9095786h1.747261l2.552178 6.7048036 2.715211-6.7048036h1.548379z" />
                    <path d="m0 1.657465h6.42995357l5.95707503 18.1793643h.0623107l5.8367214-18.1793643h4.0152l-8.0312536 24.9387964h-6.05267496z" />
                    <path d="m38.7633246 26.5965175c-1.0072142.27485-2.0408892.412275-3.0720035.412275-1.6644643 0-3.35795-.2722893-4.1748179-2.0664964h-.376425c-1.1275678 1.3785178-2.5086464 2.0664964-4.2320071 2.0664964-2.9482357 0-5.4568822-2.1364893-5.4568822-5.5516286 0-5.4159107 4.9242536-6.5895714 6.9600215-6.5895714h3.1052928v-1.1719536c0-1.7233607-1.0012393-2.4838928-3.0114-2.4838928-1.8488357 0-3.9520357.5189714-5.5490678 1.58935v-4.1415286c2.0690571-.82540357 4.2311535-1.17366071 6.3983714-1.17366071 6.4291 0 7.8392 2.62302501 7.8392 6.24558211v7.2758429c0 .794675-.0307286 1.8650536.9722178 1.8650536h.5975zm-7.2468214-8.0022321h-1.224875c-1.033675 0-3.1641893.1032821-3.1641893 2.3439071 0 1.1403714.7187072 1.9341929 1.7890857 1.9341929 1.0328215 0 1.9743108-.6196929 2.5999786-1.4826536z" />
                    <path d="m48.2896939 11.4180543h.3755715c1.0353821-2.34476073 3.1351678-3.93155001 5.5541892-3.93155001 3.447575 0 5.048875 2.55132501 5.048875 5.82989281v13.2798643h-6.0543821v-11.2108071c0-1.2419464.0640179-2.9311643-1.4732643-2.9311643-1.3819321 0-2.4156071 1.5526464-3.0754178 2.7237464v11.418225h-6.052675v-18.6949214h6.052675z" />
                    <path d="m85.9773479 1.03726c7.367175 0 12.2624071 4.8278 12.2624071 13.1057357 0 8.2804964-4.8952321 13.0733-12.2624071 13.0733-7.3680286 0-12.2948429-4.7928036-12.2948429-13.0733 0-8.2779357 4.9268143-13.1057357 12.2948429-13.1057357m0 22.041775c4.26615 0 5.8333071-4.9344964 5.8333071-8.9360393 0-3.9998357-1.5671571-8.96847499-5.8333071-8.96847499-4.2977322 0-5.8683036 4.96863929-5.8683036 8.96847499 0 4.0015429 1.5705714 8.9360393 5.8683036 8.9360393" />
                    <path d="m100.495574 17.2501664c0-3.4177 1.382785-9.76400354 9.439646-9.76400354 8.061129 0 9.471229 6.34630354 9.471229 9.76400354 0 3.4134322-1.4101 9.7597357-9.471229 9.7597357-8.056861 0-9.439646-6.3463035-9.439646-9.7597357m9.439646 6.0373107c2.446336 0 3.042982-4.0382464 3.042982-6.0373107 0-2.0007714-.596646-6.0364571-3.042982-6.0364571-2.414754 0-3.010546 4.0356857-3.010546 6.0364571 0 1.9990643.595792 6.0373107 3.010546 6.0373107" />
                    <path d="m128.844303 11.4180543h.374717c1.032822-2.34476073 3.136022-3.93155001 5.550775-3.93155001h.687125v5.86403571c-.71956-.3456964-1.503139-.4814143-2.285864-.4814143-1.663611 0-3.042982.7221214-3.952036 2.3089107v11.418225h-6.056089v-18.6949214h6.056089z" />
                    <path d="m149.728464 23.0788643h-.374718c-.94405 2.4488964-2.978111 3.9306964-5.394571 3.9306964-4.925108 0-6.61774-4.6195286-6.61774-9.3124643 0-5.0352178 1.976018-10.20956783 7.246822-10.20956783 2.131368 0 3.132607.68883214 4.765489 2.06905714h.374718l-.374718-1.655075v-7.90151071h6.052675v26.5981393h-6.052675zm-.374718-9.8672857c-.5975-1.033675-1.475825-1.7899393-2.6051-1.7899393-2.351589 0-2.977257 3.7932714-2.977257 5.7581928 0 1.8624929.469464 4.8627965 2.694725 4.8627965 1.411807 0 2.320007-1.3793715 2.887632-2.6204643z" />
                  </g>
                </g>
              </svg>
              <span className="styleguide__subtitle" aria-hidden="true">
                Styleguide
              </span>
            </a>

            <button
              className="styleguide-toggler"
              onClick={() => document.documentElement.classList.toggle('styleguide-nav--toggled')}
            >
              <span className="sr-text">Toggle Menu</span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
              <span aria-hidden="true"></span>
            </button>
          </div>

          <div className="styleguide-nav__wrapper styleguide--styled" data-active-page={currentPath}>
            <nav className="styleguide-nav">
              <h2 className="sr-text">Menu</h2>

              <ul className="styleguide-nav__list">
                <li className="styleguide-nav__item styleguide-nav--about">
                  <a
                    className="styleguide-nav__link"
                    href="/styleguide/about"
                    onClick={(): void => {
                      if (window.innerWidth < $breakpoint)
                        document.documentElement.classList.remove('styleguide-nav--toggled')
                    }}
                  >
                    About
                  </a>
                </li>
                <li className="styleguide-nav__item styleguide-nav--tokens">
                  <a
                    className="styleguide-nav__link styleguide-nav__toggler"
                    href="/styleguide/tokens"
                    onClick={(): void => {
                      document.documentElement.classList.toggle('styleguide-tokens--toggled')
                    }}
                  >
                    Design Tokens
                  </a>

                  <ul className="styleguide-nav__sublist">
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint) {
                            document.documentElement.classList.remove('styleguide-nav--toggled'),
                              apply_token_to_url('tokens-colors')
                          }
                        }}
                      >
                        Colors
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint) {
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          }
                          apply_token_to_url('tokens-fonts')
                        }}
                      >
                        Fonts
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint) {
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          }
                          apply_token_to_url('tokens-styles')
                        }}
                      >
                        Font Styles
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint) {
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          }
                          apply_token_to_url('tokens-sizes-heights')
                        }}
                      >
                        Font Sizes &amp; Line Heights
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint) {
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          }
                          apply_token_to_url('tokens-widths')
                        }}
                      >
                        Widths
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('tokens-spacings-gutters')
                        }}
                      >
                        Spacings &amp; Gutters
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('tokens-transitions')
                        }}
                      >
                        Transitions
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="styleguide-nav__item styleguide-nav--objects">
                  <a
                    className="styleguide-nav__link styleguide-nav__toggler"
                    href="/styleguide/objects"
                    onClick={(): void => {
                      document.documentElement.classList.toggle('styleguide-objects--toggled')
                    }}
                  >
                    Design Objects
                  </a>

                  <ul className="styleguide-nav__sublist">
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('objects-typography')
                        }}
                      >
                        Typography
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('objects-clickables')
                        }}
                      >
                        Clickables
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('objects-lists')
                        }}
                      >
                        Lists
                      </a>
                    </li>

                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('objects-expand')
                        }}
                      >
                        Expander
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('objects-pagination')
                        }}
                      >
                        Pagination - not complete
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('objects-layout-grid')
                        }}
                      >
                        Layout Grid
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="styleguide-nav__item styleguide-nav--components">
                  <a
                    className="styleguide-nav__link styleguide-nav__toggler"
                    href="/styleguide/components"
                    onClick={(): void => {
                      document.documentElement.classList.toggle('styleguide-components--toggled')
                    }}
                  >
                    Design Components
                  </a>

                  <ul className="styleguide-nav__sublist">
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-header')
                        }}
                      >
                        Redesign - Site header
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-pageheader')
                        }}
                      >
                        Redesign - Pageheaders
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-cta')
                        }}
                      >
                        Redesign - CTA Blocks
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-download')
                        }}
                      >
                        Redesign(ish) - Download Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-expandable')
                        }}
                      >
                        Redesign(ish) - Expandable Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-grid')
                        }}
                      >
                        Redesign - Grid Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-media')
                        }}
                      >
                        Redesign(ish) - Media Block
                      </a>
                    </li>

                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-quote')
                        }}
                      >
                        Redesign - Quote Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-office')
                        }}
                      >
                        Redesign(ish) - Office Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-text')
                        }}
                      >
                        Redesign(ish) - Text Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-others')
                        }}
                      >
                        Other Key Projects Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-related')
                        }}
                      >
                        Related Content Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-development')
                        }}
                      >
                        Development Block
                      </a>
                    </li>

                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-press')
                        }}
                      >
                        Press Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-update')
                        }}
                      >
                        Updates Block
                      </a>
                    </li>

                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-generic')
                        }}
                      >
                        Generic header
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-results')
                        }}
                      >
                        Results header
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-project')
                        }}
                      >
                        Project header
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-expertise')
                        }}
                      >
                        Expertise header
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-detail')
                        }}
                      >
                        Updates detail page header
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-footer')
                        }}
                      >
                        Footer
                      </a>
                    </li>

                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-gallery')
                        }}
                      >
                        Gallery Block
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('components-text-image')
                        }}
                      >
                        Text with images Block
                      </a>
                    </li>
                  </ul>
                </li>
                <li className="styleguide-nav__item styleguide-nav--compositions">
                  <a
                    className="styleguide-nav__link styleguide-nav__toggler"
                    href="/styleguide/compositions"
                    onClick={(): void => {
                      document.documentElement.classList.toggle('styleguide-compositions--toggled')
                    }}
                  >
                    Design Compositions
                  </a>
                  <ul className="styleguide-nav__sublist">
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('compositions-page')
                        }}
                      >
                        Page
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('compositions-updates')
                        }}
                      >
                        Updates overview
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('compositions-vacancies')
                        }}
                      >
                        Vacancies overview
                      </a>
                    </li>
                    <li className="styleguide-nav__item">
                      <a
                        className="styleguide-nav__link"
                        onClick={(): void => {
                          if (window.innerWidth < $breakpoint)
                            document.documentElement.classList.remove('styleguide-nav--toggled')
                          apply_token_to_url('compositions-search')
                        }}
                      >
                        Search page
                      </a>
                    </li>
                  </ul>
                </li>
              </ul>
            </nav>

            <div className="styleguide__extra styleguide--styled">
              <a className="styleguide__extra-link" href="https://www.viddadigital.com">
                by Vidda
              </a>
            </div>
          </div>
        </header>

        <div className="styleguide__content">
          {currentPath == '/about'
            ? styleguideAbout.run(() => {})
            : currentPath == '/guidelines'
            ? styleguideGuidelines.run(() => {})
            : currentPath == '/tokens'
            ? styleguideTokens.run(() => {})
            : currentPath == '/objects'
            ? styleguideObjects.run(() => {})
            : currentPath == '/components'
            ? styleguideComponents.run(() => {})
            : currentPath == '/compositions'
            ? styleguideCompositions.run(() => {})
            : styleguideAbout.run(() => {})}
        </div>
      </div>
    </article>
  )
}

// Close styleguide menu when pressing the escape key
window.addEventListener('keyup', (e) => {
  if (e.keyCode === 27) {
    document.documentElement.classList.remove('styleguide-nav--toggled')
  }
})

// Close styleguide menu when clicking outside of styleguide header/menu
document.documentElement.addEventListener('click', (e) => {
  const target: HTMLElement = (e.target as HTMLElement) || (e.currentTarget as HTMLElement)

  if (
    target.closest('.styleguide__header') === null &&
    document.documentElement.classList.contains('styleguide-nav--toggled')
  ) {
    document.documentElement.classList.remove('styleguide-nav--toggled')
  }
})
